import React from "react";
import PropTypes from "prop-types";
import { Input, Icon } from "antd";

import style from "./style.module.scss";

export const RoundedSearch = ({ className: propClassName, onSearch, item, loading, ...restProps }) => {
  const baseClass = item && item === 'report' ? style.roundedSearchReport : style.roundedSearch;
  const className = propClassName ? `${baseClass} ${propClassName}` : baseClass;
  return (
    <Input
      {...restProps}
      className={className}
      prefix={<Icon type={loading ? 'loading' : 'search'} style={{ color: 'rgba(0,0,0,.45)' }} />}
      onPressEnter={(e) => onSearch && onSearch(e.target.value)}
    />
  );
};

RoundedSearch.propTypes = {};

RoundedSearch.defaultProps = {};
